import { render, staticRenderFns } from "./NewResultFilterChips.vue?vue&type=template&id=42d42816&"
import script from "./NewResultFilterChips.vue?vue&type=script&lang=js&"
export * from "./NewResultFilterChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports